// Click-to-expand for in-content images and galleries, via PhotoSwipe
// (assets/js/lib/photoswipe*.min.js, partials/lightbox.hbs). This is
// the same mechanism Ghost's own Casper theme uses -- ported rather
// than reinvented, since it already handles the tricky part: walking
// adjacent image/gallery cards so Prev/Next flows across a whole run
// of them as one album, not just within a single gallery card.

function getItem(image) {
    const width = image.getAttribute("width");
    const height = image.getAttribute("height");

    // Images without dimensions in the markup, like feature images, are
    // measured from the source the browser picked out of the srcset
    const src = width && height ? image.getAttribute("src") : (image.currentSrc || image.getAttribute("src"));

    return {
        src,
        msrc: src,
        w: width || image.naturalWidth,
        h: height || image.naturalHeight,
        el: image,
    };
}

function onThumbnailClick(event) {
    event.preventDefault();

    const pswpElement = document.querySelector(".pswp");
    if (!pswpElement) {
        return false;
    }

    let items = [];
    let index = 0;

    // Feature images live outside the content, so they open on their own
    const card = event.target.closest(".kg-card");

    if (card) {
        let prevSibling = card.previousElementSibling;

        while (prevSibling && (prevSibling.classList.contains("kg-image-card") || prevSibling.classList.contains("kg-gallery-card"))) {
            const prevItems = [];

            prevSibling.querySelectorAll("img").forEach((item) => {
                prevItems.push(getItem(item));
                index += 1;
            });
            prevSibling = prevSibling.previousElementSibling;

            items = prevItems.concat(items);
        }
    }

    if (!card || event.target.classList.contains("kg-image")) {
        items.push(getItem(event.target));
    } else {
        let reachedCurrentItem = false;

        event.target.closest(".kg-gallery-card").querySelectorAll("img").forEach((item) => {
            items.push(getItem(item));

            if (!reachedCurrentItem && item !== event.target) {
                index += 1;
            } else {
                reachedCurrentItem = true;
            }
        });
    }

    if (card) {
        let nextSibling = card.nextElementSibling;

        while (nextSibling && (nextSibling.classList.contains("kg-image-card") || nextSibling.classList.contains("kg-gallery-card"))) {
            nextSibling.querySelectorAll("img").forEach((item) => {
                items.push(getItem(item));
            });
            nextSibling = nextSibling.nextElementSibling;
        }
    }

    const options = {
        bgOpacity: 0.9,
        closeOnScroll: true,
        fullscreenEl: false,
        history: false,
        index,
        shareEl: false,
        zoomEl: false,
        getThumbBoundsFn(i) {
            const thumbnail = items[i].el;
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            const rect = thumbnail.getBoundingClientRect();

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
    };

    const gallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, items, options);

    // An image can be clicked before it has finished decoding, in which case
    // there's nothing to measure yet -- load it and correct the size after
    gallery.listen("gettingData", (i, item) => {
        if (item.w > 0 && item.h > 0) {
            return;
        }

        const image = new Image();
        image.onload = function () {
            item.w = this.naturalWidth;
            item.h = this.naturalHeight;
            gallery.invalidateCurrItems();
            gallery.updateSize(true);
        };
        image.src = item.src;
    });

    gallery.init();

    return false;
}

export default function lightbox() {
    const triggers = document.querySelectorAll(
        ".kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image"
    );

    triggers.forEach((trigger) => {
        trigger.addEventListener("click", onThumbnailClick);
    });
}
